export interface CurrencyCatalogEntry {
  id: number;
  isRefCurrency?: boolean;
}

/**
 * CEC-565. Resuelve la moneda con la que nace una cotizacion.
 *
 * El backend la exige desde este ticket -- una cotizacion sin moneda no se puede convertir y
 * deja sin KPI a toda su oportunidad -- asi que los TRES caminos de alta que existen en la app
 * tienen que resolverla igual. Antes cada uno hacia una cosa distinta: uno caia en un `|| 1`,
 * otro miraba solo la moneda de la compañia y el tercero solo la de la oportunidad. Los dos
 * ultimos podian mandar el alta sin moneda.
 *
 * `preferredCurrencyIds` son los candidatos en orden de preferencia; se coge el primero
 * utilizable. El ultimo recurso es la moneda de REFERENCIA del sistema, leida del catalogo en
 * vez de fijada como el numero 1: es un valor por defecto para un documento que se esta
 * creando ahora y que el usuario puede cambiar, no una suposicion sobre uno antiguo.
 *
 * Si no hay nada devuelve null: preferimos que el alta falle a guardar una moneda inventada.
 */
export function resolveNewQuotationCurrencyId(
  preferredCurrencyIds: unknown[],
  currencies?: CurrencyCatalogEntry[] | null,
): number | null {
  for (const candidate of preferredCurrencyIds) {
    const currencyId = toCurrencyId(candidate);
    if (currencyId !== null) {
      return currencyId;
    }
  }

  return toCurrencyId(currencies?.find((currency) => currency?.isRefCurrency)?.id);
}

function toCurrencyId(value: unknown): number | null {
  return typeof value === 'number' && Number.isInteger(value) && value > 0 ? value : null;
}
